WiseMetering.Views.ShowMeasurablIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/measurabl/show',
    title: () => i18next.t('modal.title.integrations.show'),

    // edit: function() {
    //     new WiseMetering.Views.EditMeasurablIntegration({ model: this.model });
    // },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            configurationName: this.model.configuration().get('name'),
            indicator: this.model.indicator()
        };
    }
});
